import { defineRows, FieldTemplate, TemplateRow } from '../../../app/components/fields-template/field-template';
import type { entityTypes } from '../entitytypes';
import { BASE_ROWS } from './base';

type MarkingsET = (typeof entityTypes)['markings'];

export class MarkingsTemplate implements FieldTemplate {
    rows: TemplateRow[] = defineRows<MarkingsET>([
        ...BASE_ROWS,
        {
            type: 'row',
            children: [
                {
                    type: 'div',
                    classes: 'col-24 col-md',
                    children: [
                        {
                            type: 'row',
                            children: [
                                {
                                    type: 'field',
                                    fieldKey: 'person_id',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'contacttelefoon',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'verkeersmaatregel',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md-6 col-lg',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'leverancier_verkeersmaatregel',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md-6',
                                },
                            ],
                        },
                        {
                            type: 'row',
                            children: [
                                {
                                    type: 'field',
                                    fieldKey: 'materiaal',
                                    fieldGroup: 'pheData',
                                    classes: 'col-24 col-md',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'ondergrond',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'mallen',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md-3',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'opmeten',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md-3',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'uitzetten',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md-3',
                                },
                            ],
                        },
                        {
                            type: 'row',
                            children: [
                                {
                                    type: 'field',
                                    fieldKey: 'behoefteInventarisatie',
                                    fieldGroup: 'planningData',
                                    classes: 'col-24 col-md-3',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'behoefteUren',
                                    fieldGroup: 'pheData',
                                    classes: 'col-24 col-md',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'behoefteOverigM1',
                                    fieldGroup: 'pheData',
                                    classes: 'col-24 col-md',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'behoefteOverigM2',
                                    fieldGroup: 'pheData',
                                    classes: 'col-24 col-md',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'behoefteThermoM1',
                                    fieldGroup: 'pheData',
                                    classes: 'col-24 col-md',
                                },
                                {
                                    type: 'field',
                                    fieldKey: 'behoefteThermoM2',
                                    fieldGroup: 'pheData',
                                    classes: 'col-24 col-md',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ]);
}
